import { render, staticRenderFns } from "./accountdetail.vue?vue&type=template&id=e973d518&"
import script from "./accountdetail.vue?vue&type=script&lang=js&"
export * from "./accountdetail.vue?vue&type=script&lang=js&"
import style0 from "./accountdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports